'use client';
// Third party scripts for analytics
// Refer to components/PixelScripts

let INITIALIZED = false;
const AID = 2001621371;

const EVENTS = {
	visit: 297,
	login: 298,
	regnotfin: 299,
	regfin: 300,
	purch1: 301,
};

function insertPixels() {
	if (!INITIALIZED) {
		return;
	}

	function insert(eventId: number) {
		const wn = window.navigator;
		let hc = 0;
		let vc;

		try {
			hc = wn.hardwareConcurrency;
		} catch (e) {}

		try {
			const ca = document.createElement('canvas');
			const gl = ca.getContext(
				'experimental-WEBGL'
			) as WebGL2RenderingContext | null;
			if (gl) {
				const ext = gl.getExtension('WEBGL_debug_renderer_info');
				if (ext) {
					vc = escape(gl.getParameter(ext['UNMASKED_RENDERER_WEBGL']));
				}
			}
		} catch (p) {}

		const p = {
			sr: window.screen.width + 'x' + window.screen.height,
			tz: -new Date().getTimezoneOffset(),
			pl: wn.plugins && wn.plugins.length,
			mi: wn.mimeTypes && wn.mimeTypes.length,
			me: wn.deviceMemory,
			hc,
			vc,
		};
		let q = `https://rtb.dspretargettraff.com/au?a=${eventId}&`;
		for (const k in p) {
			const v = p[k as keyof typeof p];
			if (v && v != 'undefined') {
				q += '&' + k + '=' + v;
			}
		}

		new Image().src = q;
	}

	Object.values(EVENTS).forEach(insert);
}

export function updateUserId(userId: string) {
	if (!INITIALIZED) {
		return;
	}

	window.AU = window.AU || {};
	window.AU.acl = {
		regfin: `1&extID=${userId}`,
		visit: `5&extID=${userId}`,
		login: `10&extID=${userId}`,
		regnotfin: `14&extID=${userId}`,
		purch1: `27&extID=${userId}`,
	};
}

export function callAction(action: keyof typeof EVENTS) {
	if (!INITIALIZED) {
		return;
	}

	try {
		window.AU = window.AU || {};
		window.AU.action(action);
	} catch (e) {
		//eslint-disable-next-line
		console.error('Error calling AU action:', e);
	}
}

export function init() {
	window.AU = window.AU || {};
	window.AU.aid = AID;
	window.AU.acl = {
		regfin: '1&extID=1234567890',
		visit: '5&extID=1234567890',
		login: '10&extID=1234567890',
		regnotfin: '14&extID=1234567890',
		purch1: '27&extID=1234567890',
	};

	insertPixels();

	INITIALIZED = true;
	callAction('visit');
}
